
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/movies/[projectSlug]",
      function () {
        return require("private-next-pages/[locale]/movies/[projectSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/movies/[projectSlug]"])
      });
    }
  